import { render, staticRenderFns } from "./BulkDeletePicklPopup.vue?vue&type=template&id=54407ad1&scoped=true&"
import script from "./BulkDeletePicklPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeletePicklPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeletePicklPopup.vue?vue&type=style&index=0&id=54407ad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54407ad1",
  null
  
)

export default component.exports